import styled from 'styled-components';
import { config } from './config';

const MainContainer = styled.div`
  width: 50%;
  padding: 5px;
  text-align: center;
`;

const Container = styled.div`
  display: inline-flex;
`;

const DropAreaContainer = styled.div`
  border: 3px solid ${props => props.type ? (config[props.type].color) : (config[config.default].color)};
  height: 315px;
  padding: 5px;
`;

const DropAreaLabel = styled.h1`
  color: ${props => props.type ? (config[props.type].color) : (config[config.default].color)};
  position: absolute;
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 5px;
  margin: 5px;
  padding: 10px;
`;

const ImageElement = styled.img`
  max-width: 100%;
  max-height: 190px;
`;

const CloseButton = styled.span`
  width: 20px;
  height: 20px;
  z-index: 200;
  display: block;
  float: right;
  cursor: pointer;
`;

const DropAreaElement = styled.div`
  width: 100%;
  height: calc(100% - 20px);
`;

export { MainContainer, Container, DropAreaContainer, DropAreaLabel, ImageElement, CloseButton, DropAreaElement };
